import { makeStyles } from '@material-ui/core/styles'
import { CenterFocusStrong } from '@material-ui/icons'

const signInStyles = makeStyles(theme => ({
  SignInDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 114px)'
  },
  SignInBox: {
    maxWidth: '500px',
    background: '#FFF',
    boxShadow: '0px 2px 10px #3F434714'
  },
  SignInTextBox: {
    fontWeight: 'bold',
    fontSize: '2.375em',
    padding: '0 40px',
    textAlign: 'left',
    color: '#335977'
  },
  flexSpaceBtw:
  {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  container: {
    padding: '20px 40px',
    textAlign: 'center',
    fontSize: '0.875em'
  },
  forgotPassword: {
    color: '#026AE3',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none'
  },
}))

export { signInStyles }